import React from 'react';
import { parseMsrObservationSegments } from './msrObservationParser';

export interface MsrObservationTextProps {
  text: string;
}

const MsrObservationText: React.FC<MsrObservationTextProps> = ({ text }) => (
  <>
    {parseMsrObservationSegments(text).map((seg, i) =>
      seg.bold ? (
        <strong key={i} className="font-semibold text-slate-900">
          {seg.text}
        </strong>
      ) : (
        <span key={i}>{seg.text}</span>
      )
    )}
  </>
);

export default MsrObservationText;
